import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      // Job related translations
      "Software Developer": "Software Developer",
      "Frontend Developer": "Frontend Developer", 
      "Backend Developer": "Backend Developer",
      "Full Stack Developer": "Full Stack Developer",
      "Data Analyst": "Data Analyst",
      "Business Analyst": "Business Analyst",
      "Project Manager": "Project Manager",
      "Sales Executive": "Sales Executive",
      "Marketing Executive": "Marketing Executive",
      "Customer Support": "Customer Support",
      "HR Executive": "HR Executive",
      "Accountant": "Accountant",
      "Graphic Designer": "Graphic Designer",
      "Content Writer": "Content Writer",
      "Digital Marketing": "Digital Marketing",
      
      // City names
      "Mumbai": "Mumbai",
      "Delhi": "Delhi", 
      "Bangalore": "Bangalore",
      "Hyderabad": "Hyderabad",
      "Chennai": "Chennai",
      "Kolkata": "Kolkata",
      "Pune": "Pune",
      "Ahmedabad": "Ahmedabad",
      "Gurugram": "Gurugram",
      "Noida": "Noida",
      "Gurgaon": "Gurgaon",
      "Jaipur": "Jaipur",
      "Lucknow": "Lucknow",
      "Kanpur": "Kanpur",
      "Nagpur": "Nagpur",
      "Indore": "Indore",
      "Thane": "Thane",
      "Bhopal": "Bhopal",
      "Visakhapatnam": "Visakhapatnam",
      "Pimpri": "Pimpri",
      
      // Common job description terms
      "Experience required": "Experience required",
      "Fresher": "Fresher",
      "Immediate joining": "Immediate joining",
      "Work from home": "Work from home",
      "Full time": "Full time",
      "Part time": "Part time",
      "Contract": "Contract",
      "Internship": "Internship",
      "Remote": "Remote",
      "On-site": "On-site",
      "Hybrid": "Hybrid"
    }
  },
  hi: {
    translation: {
      // Job related translations in Hindi
      "Software Developer": "सॉफ्टवेयर डेवलपर",
      "Frontend Developer": "फ्रंटएंड डेवलपर",
      "Backend Developer": "बैकएंड डेवलपर", 
      "Full Stack Developer": "फुल स्टैक डेवलपर",
      "Data Analyst": "डेटा विश्लेषक",
      "Business Analyst": "व्यापार विश्लेषक",
      "Project Manager": "परियोजना प्रबंधक",
      "Sales Executive": "बिक्री कार्यकारी",
      "Marketing Executive": "मार्केटिंग कार्यकारी",
      "Customer Support": "ग्राहक सहायता",
      "HR Executive": "एचआर कार्यकारी",
      "Accountant": "लेखाकार",
      "Graphic Designer": "ग्राफिक डिजाइनर",
      "Content Writer": "सामग्री लेखक",
      "Digital Marketing": "डिजिटल मार्केटिंग",
      
      // City names in Hindi
      "Mumbai": "मुंबई",
      "Delhi": "दिल्ली",
      "Bangalore": "बेंगलुरु", 
      "Hyderabad": "हैदराबाद",
      "Chennai": "चेन्नई",
      "Kolkata": "कोलकाता",
      "Pune": "पुणे",
      "Ahmedabad": "अहमदाबाद",
      "Gurugram": "गुरुग्राम",
      "Noida": "नोएडा",
      "Gurgaon": "गुड़गांव",
      "Jaipur": "जयपुर",
      "Lucknow": "लखनऊ",
      "Kanpur": "कानपुर",
      "Nagpur": "नागपुर",
      "Indore": "इंदौर",
      "Thane": "ठाणे",
      "Bhopal": "भोपाल",
      "Visakhapatnam": "विशाखापत्तनम",
      "Pimpri": "पिंपरी",
      
      // Common job description terms in Hindi
      "Experience required": "अनुभव आवश्यक",
      "Fresher": "नया",
      "Immediate joining": "तत्काल ज्वाइनिंग",
      "Work from home": "घर से काम",
      "Full time": "पूर्णकालिक",
      "Part time": "अंशकालिक", 
      "Contract": "अनुबंध",
      "Internship": "इंटर्नशिप",
      "Remote": "दूरस्थ",
      "On-site": "साइट पर",
      "Hybrid": "हाइब्रिड"
    }
  },
  gu: {
    translation: {
      // Job related translations in Gujarati
      "Software Developer": "સોફ્ટવેર ડેવલપર",
      "Frontend Developer": "ફ્રન્ટએન્ડ ડેવલપર",
      "Backend Developer": "બેકએન્ડ ડેવલપર",
      "Full Stack Developer": "ફુલ સ્ટેક ડેવલપર",
      "Data Analyst": "ડેટા વિશ્લેષક",
      "Business Analyst": "બિઝનેસ વિશ્લેષક",
      "Project Manager": "પ્રોજેક્ટ મેનેજર",
      "Sales Executive": "સેલ્સ એક્ઝિક્યુટિવ",
      "Marketing Executive": "માર્કેટિંગ એક્ઝિક્યુટિવ",
      "Customer Support": "ગ્રાહક સહાયતા",
      "HR Executive": "એચઆર એક્ઝિક્યુટિવ",
      "Accountant": "એકાઉન્ટન્ટ",
      "Graphic Designer": "ગ્રાફિક ડિઝાઇનર",
      "Content Writer": "કન્ટેન્ટ રાઇટર",
      "Digital Marketing": "ડિજિટલ માર્કેટિંગ",
      
      // City names in Gujarati
      "Mumbai": "મુંબઈ",
      "Delhi": "દિલ્હી",
      "Bangalore": "બેંગલોર",
      "Hyderabad": "હૈદરાબાદ",
      "Chennai": "ચેન્નઈ",
      "Kolkata": "કોલકાતા",
      "Pune": "પુણે",
      "Ahmedabad": "અમદાવાદ",
      "Gurugram": "ગુરુગ્રામ",
      "Noida": "નોઈડા",
      "Gurgaon": "ગુડગાંવ",
      "Jaipur": "જયપુર",
      "Lucknow": "લખનઉ",
      "Kanpur": "કાનપુર",
      "Nagpur": "નાગપુર",
      "Indore": "ઇન્દોર",
      "Thane": "ઠાણે",
      "Bhopal": "ભોપાલ",
      "Visakhapatnam": "વિશાખાપત્તનમ",
      "Pimpri": "પિંપરી",
      
      // Common job description terms in Gujarati
      "Experience required": "અનુભવ જરૂરી",
      "Fresher": "નવો",
      "Immediate joining": "તાત્કાલિક જોઇનિંગ",
      "Work from home": "ઘરેથી કામ",
      "Full time": "પૂર્ણ સમય",
      "Part time": "અંશ સમય",
      "Contract": "કરાર",
      "Internship": "ઇન્ટર્નશિપ",
      "Remote": "દૂરસ્થ",
      "On-site": "સાઇટ પર",
      "Hybrid": "હાઇબ્રિડ"
    }
  },
  ta: {
    translation: {
      // Job related translations in Tamil
      "Software Developer": "மென்பொருள் உருவாக்குநர்",
      "Frontend Developer": "முன்பக்க உருவாக்குநர்",
      "Backend Developer": "பின்பக்க உருவாக்குநர்",
      "Full Stack Developer": "முழு அடுக்கு உருவாக்குநர்",
      "Data Analyst": "தரவு ஆய்வாளர்",
      "Business Analyst": "வணிக ஆய்வாளர்",
      "Project Manager": "திட்ட மேலாளர்",
      "Sales Executive": "விற்பனை நிர்வாகி",
      "Marketing Executive": "சந்தைப்படுத்தல் நிர்வாகி",
      "Customer Support": "வாடிக்கையாளர் ஆதரவு",
      "HR Executive": "மனித வள நிர்வாகி",
      "Accountant": "கணக்காளர்",
      "Graphic Designer": "கிராஃபிக் வடிவமைப்பாளர்",
      "Content Writer": "உள்ளடக்க எழுத்தாளர்",
      "Digital Marketing": "டிஜிட்டல் மார்க்கெட்டிங்",
      
      // City names in Tamil
      "Mumbai": "மும்பை",
      "Delhi": "டெல்லி",
      "Bangalore": "பெங்களூரு",
      "Hyderabad": "ஹைதராபாத்",
      "Chennai": "சென்னை",
      "Kolkata": "கொல்கத்தா",
      "Pune": "புணே",
      "Ahmedabad": "அகமதாபாத்",
      "Gurugram": "குருகிராம்",
      "Noida": "நொய்டா",
      "Gurgaon": "குர்கான்",
      "Jaipur": "ஜெய்ப்பூர்",
      "Lucknow": "லக்னோ",
      "Kanpur": "கான்பூர்",
      "Nagpur": "நாக்பூர்",
      "Indore": "இந்தூர்",
      "Thane": "தானே",
      "Bhopal": "போபால்",
      "Visakhapatnam": "விசாகப்பட்டினம்",
      "Pimpri": "பிம்ப்ரி",
      
      // Common job description terms in Tamil
      "Experience required": "அனுபவம் தேவை",
      "Fresher": "புதியவர்",
      "Immediate joining": "உடனடி சேர்க்கை",
      "Work from home": "வீட்டிலிருந்து வேலை",
      "Full time": "முழு நேரம்",
      "Part time": "பகுதி நேரம்",
      "Contract": "ஒப்பந்தம்",
      "Internship": "பயிற்சி",
      "Remote": "தொலைநிலை",
      "On-site": "தளத்தில்",
      "Hybrid": "கலப்பின"
    }
  },
  te: {
    translation: {
      // Job related translations in Telugu
      "Software Developer": "సాఫ్ట్‌వేర్ డెవలపర్",
      "Frontend Developer": "ఫ్రంట్‌ఎండ్ డెవలపర్",
      "Backend Developer": "బ్యాకెండ్ డెవలపర్",
      "Full Stack Developer": "ఫుల్ స్టాక్ డెవలపర్",
      "Data Analyst": "డేటా విశ్లేషకుడు",
      "Business Analyst": "వ్యాపార విశ్లేషకుడు",
      "Project Manager": "ప్రాజెక్ట్ మేనేజర్",
      "Sales Executive": "సేల్స్ ఎగ్జిక్యూటివ్",
      "Marketing Executive": "మార్కెటింగ్ ఎగ్జిక్యూటివ్",
      "Customer Support": "కస్టమర్ సపోర్ట్",
      "HR Executive": "HR ఎగ్జిక్యూటివ్",
      "Accountant": "అకౌంటెంట్",
      "Graphic Designer": "గ్రాఫిక్ డిజైనర్",
      "Content Writer": "కంటెంట్ రైటర్",
      "Digital Marketing": "డిజిటల్ మార్కెటింగ్",
      
      // City names in Telugu
      "Mumbai": "ముంబై",
      "Delhi": "ఢిల్లీ",
      "Bangalore": "బెంగళూరు",
      "Hyderabad": "హైదరాబాద్",
      "Chennai": "చెన్నై",
      "Kolkata": "కోల్‌కతా",
      "Pune": "పూణే",
      "Ahmedabad": "అహ్మదాబాద్",
      "Gurugram": "గురుగ్రామ్",
      "Noida": "నోయిడా",
      "Gurgaon": "గుర్గావ్",
      "Jaipur": "జైపూర్",
      "Lucknow": "లక్నో",
      "Kanpur": "కాన్పూర్",
      "Nagpur": "నాగ్‌పూర్",
      "Indore": "ఇందోర్",
      "Thane": "థానే",
      "Bhopal": "భోపాల్",
      "Visakhapatnam": "విశాఖపట్నం",
      "Pimpri": "పింప్రి",
      
      // Common job description terms in Telugu
      "Experience required": "అనుభవం అవసరం",
      "Fresher": "కొత్తవారు",
      "Immediate joining": "తక్షణ చేరిక",
      "Work from home": "ఇంటి నుండి పని",
      "Full time": "పూర్తి సమయం",
      "Part time": "పార్ట్ టైమ్",
      "Contract": "కాంట్రాక్ట్",
      "Internship": "ఇంటర్న్‌షిప్",
      "Remote": "రిమోట్",
      "On-site": "ఆన్-సైట్",
      "Hybrid": "హైబ్రిడ్"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // default language
    fallbackLng: 'en', // fallback language
    
    interpolation: {
      escapeValue: false // react already does escaping
    },
    
    // Enable debug mode for development
    debug: process.env.NODE_ENV === 'development'
  });

export default i18n;
